

import React, { useEffect, useState } from 'react';
// import './payments.css';

import { getAllPaymentsReport } from '../../services/dashbboard/adminReportService';



export default function AllPayments() {
  const [payments, setPayments] = useState([]);


    const loadData = async ()=>{
        const items = await getAllPaymentsReport();
        setPayments(items.data);
    }

  useEffect( () => {

        loadData();

    // fetch('/api/payments')
    //   .then((res) => res.json())
    //   .then(setPayments)
    //   .catch(console.error);
  }, []);

  return (
    <div className="container">
      <h2>همه پرداخت‌ها</h2>
      <table className="table table-hovered payments-table">
        <thead>
          <tr>
            <th>کاربر</th>
            <th>پلن</th>
            <th>مبلغ</th>
            <th>وضعیت</th>
            <th>درگاه</th>
            <th>تاریخ</th>
          </tr>
        </thead>
        <tbody>
          {payments.map((p) => (
            <tr key={p._id}>
              <td>{p.user?.phone} <br /><small>{p.user?.validDueDate}</small></td>
              <td>{p.plan?.name} ({p.plan?.maxReminders})</td>
              <td>{p.amount} {p.currency === 0 ? 'IRR' : p.currency}</td>
              <td className={`status ${p.status}`}>{p.status}</td>
              <td>{p.gateway}</td>
              <td>{new Date(p.createdAt).toLocaleString()}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
